import Initials, {
  type InitialsProps,
} from '@schibsted-svp/react-ui/lib/es/Initials/Initials';
import classNames from 'classnames';

import type { UserResponse } from '../../types';
import type { FC } from 'react';

import styles from './UserInitials.module.scss';

export const UserInitials: FC<
  Omit<InitialsProps, 'children'> & { user?: UserResponse }
> = ({ user, className, ...props }) => {
  if (!user) {
    return null;
  }

  const fullName = `${user.firstName} ${user.lastName}`;
  return (
    <Initials className={classNames(styles.root, className)} {...props}>
      {fullName}
    </Initials>
  );
};
